import React from "react";
import ContentSection from "../../../../components/common/content-section";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import "./licencing-options.scss";

const LicencingOptions = () => {
  return (
    <ContentSection>
      <h1 className="text-center">Further Licencing Options Available</h1>
      <Row>
        <Col md={6}>
          <img
            src="/images/trial-and-subscribe/licence-options.jpg"
            alt=""
            className="rnd-img"
          />
        </Col>
        <Col md={6}>
          <p>
            We offer a range of licencing options to best serve our corporate
            and project clients globally.
          </p>
          <p>
            We have standardised licencing streams and will work with you to
            find the most suitable and cost-effective solution in meeting your
            business or project requirements.
          </p>
          <p>
            Upon engagement and by our discretion we can offer to organisations
            an opportunity to corporately trial XerTransfer within a controlled
            process to assist an organisation in understanding it&rsquo;s
            procurement needs, orientate users and measure the benefits
            XerTransfer provides to the organisation.
          </p>
          <p>
            For information and licencing contact 
            <a href="mailto:exec@xertransfer.com">exec@xertransfer.com</a>
          </p>
          <div>
            <Link to="/contact-us/" className="sw-std-btn">
              Contact XerTransfer for Licencing Options
            </Link>
          </div>
        </Col>
        <Col className="licence-types">
          <ul className="box-list">
            <li>
              <span>
                XerTransfer Corporate Licencing Concurrent &amp; Multiuser
              </span>
            </li>
            <li>
              <span>XerTransfer Project Licencing</span>
            </li>
            <li>
              <span>XerTransfer Commercial Licencing</span>
            </li>
            <li>
              <span>XerTransfer Enterprise Licencing</span>
            </li>
          </ul>
        </Col>
      </Row>
    </ContentSection>
  );
};

export default LicencingOptions;
